import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { RoutingsService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchAMAgencies = (
  extraOptions?: UseQueryOptions<string[], unknown, string[], QueryKeys[]>
) => {
  return useQuery(
    [QueryKeys.fetchAmAgencies],
    async () => {
      return RoutingsService.routingsControllerFetchAgencies();
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération des agences');
      },
      ...extraOptions,
    }
  );
};
